<div class="page-innder-body portlet light mx-3 my-3"
  [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}">
  <div class="portlet-body">
    <div class="row mt-3">
      <!-- First Card -->
      <div class="col-12 col-md-3 mb-3">
        <div class="card border-primary rounded shadow">
          <div class="card-body">
            <span>
              <i class="fa fa-calendar text-primary "></i> {{ 'artistDashboard.itemsSoldThisYear' | transloco }}
            </span>
            <div class="fw-bold">{{ dashboardData.ItemsSoldThisYear}}</div>
          </div>
        </div>
      </div>
      <!-- Second Card -->
      <div class="col-12 col-md-3 mb-3">
        <div class="card border-success rounded shadow">
          <div class="card-body">
            <span>
              <i class="fa fa-shopping-cart text-success "></i> {{ 'artistDashboard.revenueThisMonth' | transloco }}
            </span>
            <div>
              <div class="fw-bold">
                {{ dashboardData.RevenueThisMonth | currency:'USD':'symbol':'1.2-2' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Third Card -->
      <div class="col-12 col-md-3 mb-3">
        <div class="card border-warning rounded shadow">
          <div class="card-body">
            <span>
              <i class="fa fa-shopping-cart text-info "></i> {{ 'artistDashboard.revenueYearToDate' | transloco }}
            </span>
            <div>
              <div class="fw-bold">{{dashboardData.RevenueThisYear | currency:'USD':'symbol':'1.2-2' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Fourth Card -->
      <div class="col-12 col-md-3 mb-3">
        <div class="card border-info rounded shadow">
          <div class="card-body">
            <span>
              <i class="fa fa-briefcase text-warning"></i> {{ 'artistDashboard.consignmentThisYear' | transloco }}
            </span>
            <div>
              <div class="fw-bold">
                {{ dashboardData.TotalConsignmentsThisYear }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between w-100 my-4">
    <!-- First Column -->
    <div class="dsDashBoard50 dsGalleryList px-3 py-2 border me-3 flex-grow-1 rounded shadow">
      <table class="table table-sm mb-0 text-center align-middle">
        <thead>
          <tr>
            <th class="text-start">{{ 'artistDashboard.galleries' | transloco }}</th>
            <th class="d-none d-md-table-cell">{{ 'artistDashboard.thirtyDays' | transloco }}</th>
            <th class="d-none d-md-table-cell">{{ 'artistDashboard.year' | transloco }}</th>
            <th class="d-none d-md-table-cell">{{ 'artistDashboard.sold' | transloco }}</th>
            <th class="d-none d-md-table-cell">{{ 'artistDashboard.available' | transloco }}</th>
            <th class="text-center">{{ 'artistDashboard.socials' | transloco }}</th> <!-- Move Socials column to last -->
          </tr>
        </thead>
        <tbody>
          @for (rowData of dashboardData.Galleries; track rowData) {
            <tr>
              <!-- Gallery Name -->
              <td class="text-start">
                <div class="d-flex">
                  <img [src]="rowData.GalleryLogoUrl || 'assets/images/No-Image.png'"
                    class="me-2 rounded-circle border"
                    style="height: 35px; width: 35px; object-fit: cover;" />
                    <a class="text-uppercase fw-semibold text-truncate d-inline-block"
                      style="max-width: 120px;"
                      [routerLink]="['/artists','gallery', rowData.GalleryId, 'gallery-products']">
                      {{ rowData.GalleryName }}
                    </a>
                  </div>
                </td>
                <!-- Hidden Columns on Mobile -->
                <td class="d-none d-md-table-cell">{{ rowData.MonthlySales || 0 |
                currency:'USD':'symbol':'1.2-2' }}</td>
                <td class="d-none d-md-table-cell">{{ rowData.YearlySales || 0 | currency:'USD':'symbol':'1.2-2'
                }}</td>
                <td class="d-none d-md-table-cell">
                  <span>{{ rowData.NoOfSoldArtworks || 0 }}</span><br>
                  <small>{{ rowData.TotalSoldPriceOfSoldItems || 0 | currency:'USD':'symbol':'1.2-2'
                  }}</small>
                </td>
                <td class="d-none d-md-table-cell">
                  <span>{{ rowData.NoOfAvailableArtworks || 0 }}</span><br>
                  <small>{{ rowData.TotalRetailPriceOfAvailableItems || 0 | currency:'USD':'symbol':'1.2-2'
                  }}</small>
                </td>
                <!-- Social Links - LAST COLUMN -->
                <td class="text-center">
                  <div class="d-flex justify-content-center flex-row gap-1">
                    @if (rowData.GalleryEmail) {
                      <a [href]="'mailto:' + rowData.GalleryEmail"
                        target="_blank" [title]="'artistDashboard.email' | transloco">
                        <i class="fa fa-at text-muted"></i>
                      </a>
                    }
                    @if (rowData.GalleryWebsiteUrl) {
                      <a [href]="rowData.GalleryWebsiteUrl" target="_blank"
                        [title]="'artistDashboard.website' | transloco">
                        <i class="fa fa-globe text-muted"></i>
                      </a>
                    }
                    @if (rowData.GalleryInstagramUrl) {
                      <a [href]="rowData.GalleryInstagramUrl"
                        target="_blank" title="Instagram">
                        <i class="fa fa-instagram text-muted"></i>
                      </a>
                    }
                    @if (rowData.GalleryFacebookUrl) {
                      <a [href]="rowData.GalleryFacebookUrl"
                        target="_blank" title="Facebook">
                        <i class="fa fa-facebook text-muted"></i>
                      </a>
                    }
                    @if (rowData.GalleryLinkedinUrl) {
                      <a [href]="rowData.GalleryLinkedinUrl"
                        target="_blank" title="LinkedIn">
                        <i class="fa fa-linkedin text-muted"></i>
                      </a>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
          @if (!dashboardData.Galleries || dashboardData.Galleries.length === 0) {
            <tfoot>
              <tr>
                <td [attr.colspan]="6" class="text-center py-2">{{ 'artistDashboard.noRecordsFound' | transloco }}</td>
              </tr>
            </tfoot>
          }
        </table>
      </div>
      <!-- Second Column -->
      <div class="dsDashBoard50 dsBestSellers px-3 py-2 border rounded shadow">
        <div class="row justify-content-center align-items-center p-2 g-0">
          <div class="d-flex justify-content-start  mb-3">
            <div class="text-start fw-bold">{{ 'artistDashboard.bestSellingSeries' | transloco }}</div>
          </div>

          @if (dashboardData.BestPerformingSeriesData?.length == 0) {
            <div class="d-flex justify-content-center">
              <span>{{ 'artistDashboard.noRecordFound' | transloco }}</span>
            </div>
          }

          @if (dashboardData.BestPerformingSeriesData && dashboardData.BestPerformingSeriesData.length > 0) {
            <div class="dsFlexRow d-flex flex-column justify-content-start align-items-between"
              >
              @for (item of dashboardData.BestPerformingSeriesData; track item) {
                <div class="d-flex flex-wrap justify-content-between align-items-center mb-2 series-row"
                  >
                  <!-- Series Label -->
                  <div class="text-uppercase series-label">
                    {{ item.SeriesName }}
                  </div>
                  <!-- Progress + Text Percentage -->
                  <div class="d-flex align-items-center series-right">
                    <div class="dsProgress mx-2">
                      <div class="progress-bar justify-content-end">
                        <div class="progress" role="progressbar" [style.width.%]="item.PercentageOfTotal"
                          [ngClass]="item.ColorClassBasedOnPercentage">
                          <div class="progress-bar progress-bar-striped"></div>
                        </div>
                      </div>
                    </div>
                    <div [innerHTML]="item.TextBasedOnPercentage" style="width: 80px;"></div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>

    </div>

    <div class="row rounded g-3 mb-3" [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}">
      <!-- Incoming Artist Connection Requests -->
      <div class="col-12 col-md-4">
        <div class="border shadow h-100" style="height: 300px; overflow-y: auto;">
          <p-table [value]="dashboardData.IncomingArtistConnectionRequest" dataKey="Id" [rowHover]="true"
            [reorderableColumns]="true" [resizableColumns]="false" selectionMode="single">
            <ng-template pTemplate="caption">
              <div class="table-header fs-5 py-2">{{ 'artistDashboard.recentConnectionRequests' | transloco }}</div>
            </ng-template>
            <ng-template pTemplate="body" let-request>
              <tr>
                <td>
                  <div class="d-flex ">
                    <img [src]="request.ImgUrl || 'assets/images/No-Image.png'" class="roundedImages me-3" />
                    <div>
                      <div>{{request.Name}}</div>
                      <div class="mt-2 fst-italic text-muted">{{request.RequestedDate | date:'dd/MM/yyyy'}}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td><div class="text-center">{{ 'artistDashboard.noRequestsFound' | transloco }}</div></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <!-- Product Requests -->
      <div class="col-12 col-md-4">
        <div class="border shadow h-100" style="height: 300px; overflow-y: auto;">
          <p-table [value]="dashboardData.ProductRequestQueueViewModels!" dataKey="Id" [rowHover]="true"
            [reorderableColumns]="true" [resizableColumns]="false" selectionMode="single">
            <ng-template pTemplate="caption">
              <div class="table-header fs-5 py-2">{{ 'artistDashboard.recentProductRequests' | transloco }}</div>
            </ng-template>
            <ng-template pTemplate="body" let-request>
              <tr>
                <td class="p-2">
                  <div class="d-flex">
                    <img [src]="request.ProductImgUrl || 'assets/images/No-Image.png'"
                      class="me-2" style="height: 50px; width: 50px;" (click)="goToProductRequestPage()">
                      <div>
                        <div class="text-uppercase fw-semibold fs-5">{{request.ProductName}}</div>
                        <div class="fst-italic" (click)="onViewConsignmentsClicked(request)">
                          {{ 'artistDashboard.requestedBy' | transloco }} <span class="text-primary cursor-pointer ms-1">{{request.GalleryName}}</span> {{ 'artistDashboard.on' | transloco }} {{request.RequestedDate | date:'dd/MM/yyyy'}}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td><div class="text-center">{{ 'artistDashboard.noProductRequestsFound' | transloco }}</div></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <!-- Recent Chats -->
        <div class="col-12 col-md-4">
          <div class="border shadow h-100" style="height: 300px; overflow-y: auto;">
            <p-table [value]="dashboardData.ChatDatas!" dataKey="Id" [rowHover]="true"
              styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="caption">
                <div class="table-header fs-5 py-2">{{ 'artistDashboard.yourRecentChats' | transloco }}</div>
              </ng-template>
              <ng-template pTemplate="body" let-user>
                <tr>
                  <td class="p-2">
                    <div class="d-flex " (click)="ChatwithGallery(user)">
                      <img [src]="user.ImgUrl || 'assets/images/No-Image.png'"
                        class="rounded-circle me-3" style="height: 40px; width: 40px;">
                        <div class="w-100">
                          <div class="d-flex justify-content-between text-muted small">
                            <span class="fw-semibold text-primary cursor-pointer">{{user.Name}}</span>
                            <span class="fst-italic">{{user.Time | date:'dd/MM/yyyy'}}</span>
                          </div>
                          @if (user.LastMessage) {
                            <div>{{getFirstSentence(user.LastMessage)}}</div>
                          }
                          @if (!user.LastMessage) {
                            <div class="fst-italic">{{ 'artistDashboard.noMessageFound' | transloco }}</div>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr><td><div class="text-center">{{ 'artistDashboard.noGalleryChatsFound' | transloco }}</div></td></tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <!--Insight chart-->
        <div class="border shadow tab-view">
          <ng-container>
            @if (dashboardDataLoaded) {
              <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
                @for (item of dashboardData.ArtistInsightsSeriesData; track item; let i = $index) {
                  <p-tabPanel [header]="item.SeriesName">
                    <artist-insights-chart [insightsSeriesData]="item"
                    [selectedTabIndex]="selectedTabIndex"></artist-insights-chart>
                  </p-tabPanel>
                }
              </p-tabView>
            }
          </ng-container>
        </div>

        <div class="d-flex justify-content-between w-100 my-4">
          <!-- Recent Sales Column -->
          <div class="px-3 py-3 border me-3 w-100 h-100 rounded shadow">
            <div class="fw-bold">{{ 'artistDashboard.recentSales' | transloco }}</div>
            <!-- Display New Work Products -->
            <div class="container p-3">
              <div class="row">
                <!-- ADD CLASS TO CONTROL PRODUCT CARDS dsCards -->
                @if (dashboardData.RecentSales?.length == 0) {
                  <div class="d-flex justify-content-center">
                    <span>{{ 'artistDashboard.noProductsFound' | transloco }}</span>
                  </div>
                }
                @for (product of dashboardData.RecentSales; track product) {
                  <div class="dsCards recent-sales col-4 g-0">
                    <div class="d-flex flex-column border text-center mx-1 my-1 cursor-pointer"
                      (click)="goToProductDetails(product)">
                      <div class="card justify-content-center">
                        <img [src]="product.ResizedImageUrl ? product.ResizedImageUrl : 'assets/images/No-Image.png'"
                          (error)="$any($event.target).src='assets/images/No-Image.png'"
                          class="w-100 h-100" />
                        </div>
                        <div class="card-body">
                          <div class="card-title">{{ product.ProductName }}</div>
                          <div class="card-text">{{ product.GalleryName }}</div>
                          <div class="card-price fw-bolder mt-1">{{ product.SoldPrice |
                            currency:'USD':'symbol':'1.2-2' }}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <!-- New Work -->
            <div class="px-3 py-3 border w-100 h-100 rounded shadow">
              <div class="ms-2">
                <div class="fw-bold">{{ 'artistDashboard.newWork' | transloco }}</div>
                <!-- Display New Work Products -->
                <div class="container p-3">
                  <div class="row">
                    @if (dashboardData.NewProductsAdded?.length == 0) {
                      <div class="d-flex justify-content-center">
                        <span>{{ 'artistDashboard.noProductsFound' | transloco }}</span>
                      </div>
                    }
                    @for (product of dashboardData.NewProductsAdded; track product) {
                      <div class="dsCards new-work col-4 g-0">
                        <div class="d-flex flex-column border text-center mx-1 my-1 cursor-pointer"
                          (click)="goToProductDetails(product)">
                          <div class="card justify-content-center">
                            <img [src]="product.ResizedImageUrl ? product.ResizedImageUrl : 'assets/images/No-Image.png'"
                              (error)="$any($event.target).src='assets/images/No-Image.png'"
                              class="w-100 h-100" />
                            </div>
                            <div class="card-body">
                              <div class="card-title">{{ product.ProductName }}</div>
                              <div class="card-text">{{product.Category}}</div>
                              <div class="card-price fw-bolder mt-1">{{ product.ArtistRevenue |
                              currency:'USD':'symbol':'1.2-2' }}</div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>